import type { EndpointConfig } from '~/api/types'

export const MapboxEndpoints = {
  FETCH_SUGGESTIONS: 'fetch-suggestions',
  RETRIEVE_SUGGESTION: 'retrieve-suggestion',
  REVERSE_GEOCODE: 'reverse-geocode'
} as const

export type MapboxEndpointKey = keyof typeof MapboxEndpoints
export type MapboxEndpointId = (typeof MapboxEndpoints)[MapboxEndpointKey]

export const mapboxEndpointsConfig: Record<MapboxEndpointId, EndpointConfig> = {
  [MapboxEndpoints.FETCH_SUGGESTIONS]: {
    method: 'GET',
    path: '/search/searchbox/v1/suggest',
    description: 'Fetch suggestions from Mapbox'
  },
  [MapboxEndpoints.RETRIEVE_SUGGESTION]: {
    method: 'GET',
    // note the placeholder
    path: '/search/searchbox/v1/retrieve/:mapbox_id',
    description: 'Retrieve suggestion detail'
  },
  [MapboxEndpoints.REVERSE_GEOCODE]: {
    method: 'GET',
    path: '/search/geocode/v6/reverse',
    description: 'Reverse geocode coordinates to place name'
  }
}
